(function (app) {
  $(document).ready(function () {

    app.CampaignStep4 = function () {
      var appCampaign = app.Campaign().instance();
      var _this = this;

      var nameSpace = 'CampaignStep4',
        getUrl = '/api/post/schedule/:id',
        context = '.steps__wrapper.step__4',
        $context = $('.steps__wrapper.step__4'),
        dataTable = '.table__scheduled_posts-list',
        templates = {
          'postRow': app.templates["Post__campaign____row-scheduled-post"],
          'postEditMenu': app.templates["Post__campaign____edit-post-menu"]
        },
        $dateTimePickerModal = $('#datetime-picker-modal'),
        $dateTimePickerModalReschedule = $('#datetime-picker-modal-reschedule')
        ,

        defaultPageParams = {
          'pageSize': 20,
          'pageNo': 1,
          'q': '',
          'orderBy': 'dateScheduled',
          'orderByOrder': "ASC",
          'status': 'All',
        };

      /**
       * Get Hash
       * @returns {0,1,2,3}
       */
      _this.getHash = function () {
        var hash = window.location.hash;
        if (_.isEmpty(hash)) {
          hash = '#tab_0';
        }
        return $.trim(hash.replace('#', ''));
      };

      _this.isReminder = function (row) {
        var status = _.pluck(row.type, 'status');
        return status.length > 1 && status.indexOf('reminder') >= 0;
      };

      // To update Table view
      _this.updateList = function (response) {
        var $postBody = $('.table__scheduled_posts-body', $(context).context);
        // Clean up all existing data in dom
        $postBody.html('');
        $(dataTable).removeClass('loading-state');
        var stepIndex = 1;
        if (typeof response.result != 'undefined' && response.result.length) {
          _.each(response.result, function (row) {
            row.uniqueId = app.generateId();
            row.username = response.user;
            row.rowClass = '';
            row.index = ((response.currentPage - 1) * response.limitPerPage) + stepIndex++;

            var postRow = _this.renderPostRow('postRow', _.clone(row), $postBody);

            if (_this.isReminder(row)) {
              row.status = 'reminder';
              postRow = _this.renderPostRow('postRow', row, $postBody);
            }

            _this.lazyLoadImage($postBody);

          });
          app.initTooltip();
        } else {
          $('.page__no--records').show();
        }
      };


      /**
       * Render a post row
       * @param template
       * @param row
       * @param $postBody
       * @returns {jQuery|HTMLElement}
       */
      _this.renderPostRow = function (template, row, $postBody, $prePend) {
        $prePend = $prePend || false;
        var postRow = _.template(templates[template]);
        var $postRow = $(
          postRow(
            $.extend(row, {
              'status': _.isUndefined(row.status) ? 'Scheduled' : row.status,
              'image': _.isUndefined(row.image) ? null : row.image,
              'imageThumbnail': _.isUndefined(row.imageSettings) || _.isEmpty(row.imageSettings) ? null : row.imageSettings['thumbnail'],
              'imageId': _.isUndefined(row.imageSettings) || _.isEmpty(row.imageSettings) || _.isUndefined(row.imageSettings['id']) ? null : row.imageSettings['id'],
              'dateScheduled': moment(row.dateScheduled.date).format('MM/DD/YYYY @ h:mm a'),
              'dataDate': moment(row.dateScheduled.date).format('YYYY-MM-DD HH:mm:ss'),
            })
          )
        );
        if ($prePend) {
          $postRow.prependTo($postBody);
        } else {
          $postRow.appendTo($postBody);
        }
        return $postRow;
      };

      _this.lazyLoadImage = function (container) {
        $('.lazy:not(.loaded)', container).lazy({
          // called before an elements gets handled
          beforeLoad: function (element) {
            var imageSrc = element.data('src');
            element.parent().addClass('m-progress');
          },

          // called after an element was successfully handled
          afterLoad: function (element) {
            var imageSrc = element.data('src');
            element.parent().removeClass('m-progress');
          },

          // called whenever an element could not be handled
          onError: function (element) {
            var imageSrc = element.data('src');
            console.log('image "' + imageSrc + '" could not be loaded');
          },

          // called once all elements was handled
          onFinishedAll: function () {

          }
        });
      };

      _this.scheduledPostsAction = function () {
        return {
          history: function (postId) {
            var query = $.Deferred();
            var appTransport = app.transport();

            appTransport
              .setEvent('onSuccess', function (response) {
                return query.resolve(response);
              })
              .setEvent('onError', function (error) {
                app.flashMessenger('error', error.code + ' :: ' + error.message.message);
                return query.reject(error);
              })
              .setEvent('onComplete', function () {

              })
            ;
            appTransport.get('/api/post/log/' + postId);
            return query.promise();
          },

          updateCampaign: function (requestData) {
            var query = $.Deferred();
            var appTransport = app.transport();
            appTransport
              .setEvent('onSuccess', function (response) {
                return query.resolve(response);
              })
              .setEvent('onError', function (error) {
                app.flashMessenger('error', error.code + ' :: ' + error.message.message);
              })
              .setEvent('onComplete', function () {

              })
            ;
            appTransport.put('/api/post/campaign/' + _this.getCampaignId(), requestData);
            return query.promise();
          },
          delete: function (postId) {
            var query = $.Deferred();
            var appTransport = app.transport();
            appTransport
              .setEvent('onSuccess', function (response) {
                return query.resolve(response);
              })
              .setEvent('onError', function (error) {
                app.flashMessenger('error', error.code + ' :: ' + error.message.message);
              })
              .setEvent('onComplete', function () {

              })
            ;
            appTransport.delete('/api/post/schedule/' + postId);
            return query.promise();
          },
          deleteReminder: function (postId) {
            var query = $.Deferred();
            var appTransport = app.transport();
            appTransport
              .setEvent('onSuccess', function (response) {
                return query.resolve(response);
              })
              .setEvent('onError', function (error) {
                app.flashMessenger('error', error.code + ' :: ' + error.message.message);
              })
              .setEvent('onComplete', function () {

              })
            ;
            appTransport.delete('/api/post/reminder/' + postId);
            return query.promise();
          },
          mass: function () {
            return {
              delete: function (requestData) {
                requestData = requestData || {};
                var query = $.Deferred();

                var $form = $('form[name="scheduled_posts__list"]', $(context));
                var appTransport = app.transport();
                var formData = $form.serializeObject();
                requestData.ids = formData.ids;

                appTransport
                  .setRequestData(requestData)
                  .setEvent('onSuccess', function (response) {
                    return query.resolve(response);
                  })
                  .setEvent('onError', function (error) {
                    app.flashMessenger('error', error.code + ' :: ' + error.message.message);
                    return query.reject(error);
                  })
                  .setEvent('onComplete', function () {

                  })
                ;

                appTransport.delete('/api/post/schedule/');
                return query.promise();
              },
              reschedule: function () {
                var query = $.Deferred();
                var appTransport = app.transport();

                var $form = $('form[name=reschedule__form]');
                var requestData = $form.serializeObject();

                $form = $('form[name="scheduled_posts__list"]', $(context));

                var formData = $form.serializeObject();
                requestData.ids = formData.ids;

                if (typeof requestData.socialNetwork == 'undefined') {
                  app.flashMessenger('error', 'Please select social networks');
                  return query.reject();
                } else {
                  if (requestData.socialNetwork.indexOf('facebook') >= 0
                    && typeof requestData.socialProvider == 'undefined') {
                    app.flashMessenger('error', 'Please select pages to post for facebook ');
                    return query.reject();
                  }
                }

                var connectionError = false;
                _.each(requestData.socialNetwork, function (socialNetwork) {
                  var $field = $(':input[name="socialNetwork[]"][value="' + socialNetwork + '"]', $form);
                  if (typeof $field.attr('data-disconnected') != 'undefined') {
                    $field.prop('checked', false);
                    app.flashMessenger('error', 'Please connect to ' + socialNetwork);
                    connectionError = true;
                  }
                });

                if (connectionError) {
                  return query.reject();
                }

                appTransport
                  .setRequestData(requestData)
                  .setEvent('onSuccess', function (response) {
                    var $modal = $('[data-modal-reschedule-posts]');
                    $modal.modal('hide');
                    return query.resolve(response);
                  })
                  .setEvent('onError', function (error) {
                    app.flashMessenger('error', error.code + ' :: ' + error.message.message);
                    return query.reject(error);
                  })
                  .setEvent('onComplete', function () {

                  })
                ;
                appTransport.put('/api/post/schedule');
                return query.promise();
              }
            }
          }
        }
      };

      _this.context = function () {
        return context;
      };

      _this.storage = function () {
        return $.sessionStorage;
      }();

      _this.pageParams = function () {
        var key = nameSpace + '__pageParams';
        return {
          set: function (params) {
            var pageParams = $.extend({}, _this.storage.get(key), params);
            _this.storage.set(key, pageParams);
          },
          get: function () {
            return _this.storage.get(key);
          },
          reset: function () {
            var defaultPageParams = _this.getDefaultPageParams();
            delete defaultPageParams['pageSize'];
            delete defaultPageParams['orderBy'];
            delete defaultPageParams['orderByOrder'];
            delete defaultPageParams['q'];
            delete defaultPageParams['status'];
            delete defaultPageParams['date'];
            delete defaultPageParams['socialNetwork'];

            var pageParams = $.extend({}, _this.storage.get(key), defaultPageParams);
            _this.storage.set(key, pageParams);
          },
          setDefault: function () {
            _this.storage.set(key, _this.getDefaultPageParams());
          }
        }
      };

      _this.buildUrl = function (options) {
        options = _this.pageParams().get();

        // Customize below as per backend params required
        var queryBuilders = [];
        queryBuilders.push('page=' + options.pageNo);
        queryBuilders.push('limitPerPage=' + options.pageSize);
        !_.isEmpty(options.q) ? queryBuilders.push('q=' + options.q) : '';
        !_.isEmpty(options.type) ? queryBuilders.push('type=' + options.type) : '';
        !_.isEmpty(options.orderBy) ? queryBuilders.push('orderBy=' + options.orderBy + '&orderByOrder=' + options.orderByOrder) : '';
        !_.isEmpty(options.socialNetwork) ? queryBuilders.push('socialNetwork=' + options.socialNetwork) : '';
        !_.isEmpty(options.status) ? queryBuilders.push('status=' + options.status) : '';
        !_.isEmpty(options.date) ? queryBuilders.push('date=' + options.date) : '';

        return getUrl.replace(':id', _this.getCampaignId()) + encodeURI('?' + queryBuilders.join('&'));
      };

      _this.getFilters = function () {
        var options = _this.pageParams().get(), filters = {};
        filters = !_.isEmpty(options.query) ? $.extend({}, {'query': options.query}, options.queryParams) : $.extend({}, {'query': 'no-trigger'});
        filters = !_.isEmpty(options.q) ? $.extend(filters, {'search': options.q}) : filters;
        return filters;
      };

      window['getCampaignList'] = false;
      _this.getList = function (options) {
        if (window['getCampaignList'] == true) return;

        window['getCampaignList'] = true;
        $(dataTable).addClass('loading-state');
        $('.page__no--records').hide();

        var query = $.Deferred();
        var appTransport = app.transport();

        appTransport
          .setEvent('onSuccess', function (response) {
            _this.updateList({
              'result': response.posts,
              'currentPage': response.currentPage,
              'limitPerPage': response.limitPerPage
            });
            return query.resolve({'result': response.posts, 'total': response.total});
          })
          .setEvent('onError', function (error) {
            app.flashMessenger('error', error.code + ' :: ' + error.message.message);
            return query.reject(error);
          })
          .setEvent('onComplete', function () {
            window['getCampaignList'] = false;
          })
        ;

        appTransport.get(_this.buildUrl(options));
        return query.promise();
      };

      _this.pager = function () {
        return {
          init: function (response) {
            $(dataTable).mdcPager({
              counts: parseInt(response.total),
              pageSize: _this.pageParams().get()['pageSize'],
              currentPage: _this.pageParams().get()['pageNo'],
              callback: function (objpage) {
                var pageParams = {pageNo: objpage.pageno, pageSize: objpage.pagesize};
                _this.pageParams().set(pageParams);
                _this.getList();
              }
            });
          }
        }
      };

      _this.getDefaultPageParams = function () {
        return $.extend({}, {
          'orderBy': $(dataTable).attr('data-orderBy'),
          'orderByOrder': $(dataTable).attr('data-orderByOrder')
        }, defaultPageParams);
      };

      _this.getCampaignId = function () {
        var campaignId = $(":input[name=id]").val();
        if (typeof campaignId == 'undefined' || campaignId == '') {
          return false;
        }
        return campaignId;
      };


      _this.handleSocialSelection = function ($modal, $dataRow) {
        $modal.find('.field__social-network input[name="socialNetwork[]"]').prop('checked', false);
        $modal.find('input[name="socialProvider[facebook][]"]').prop('checked', false);
        $modal.find('.field__social-network--pages').hide();
        var $status = $dataRow.find('.col__status');

        var $facebook = $dataRow.find('.col__type').find('[data-provider="facebook"]');
        var $facebookCheck = $modal.find('.field__social-network input[name="socialNetwork[]"][value="facebook"]');
        $facebookCheck.closest('.checkbox').hide();

        var $linkedIn = $dataRow.find('.col__type').find('[data-provider="linkedin"]');
        var $linkedInCheck = $modal.find('.field__social-network input[name="socialNetwork[]"][value="linkedin"]');
        $linkedInCheck.closest('.checkbox').hide();

        var $twitter = $dataRow.find('.col__type').find('[data-provider="twitter"]');
        var $twitterCheck = $modal.find('.field__social-network input[name="socialNetwork[]"][value="twitter"]');
        $twitterCheck.closest('.checkbox').hide();

        if ($status.hasClass('incomplete') || $status.hasClass('error')) {
          if ($facebook.length && $facebook.attr('data-status') == 'error') {
            $facebookCheck.trigger('click');
            $modal.find('.facebook-account-row').hide();
            if ($facebook.attr('data-pages-error')) {
              var $pages = $facebook.attr('data-pages-error').split(',');
              _.each($pages, function (page) {
                var $page = $modal.find('input[name="socialProvider[facebook][]"][value=' + page + ']');
                $page.prop('checked', true);
                $page.closest('.facebook-account-row').css('display', 'table-row');
              });
            }

            $facebookCheck.closest('.checkbox').show();
          }

          if ($linkedIn.length && $linkedIn.attr('data-status') == 'error') {
            $linkedInCheck.closest('.checkbox').show();
          }

          if ($twitter.length && $twitter.attr('data-status') == 'error') {
            $twitterCheck.closest('.checkbox').show();
          }
        } else {
          $facebookCheck.closest('.checkbox').show();
          $linkedInCheck.closest('.checkbox').show();
          $twitterCheck.closest('.checkbox').show();
          $modal.find('.facebook-account-row').css('display', 'table-row');
          if ($facebook.length) {
            $facebookCheck.trigger('click');
            if ($facebook.attr('data-pages')) {
              var $pages = $facebook.attr('data-pages').split(',');
              _.each($pages, function (page) {
                $modal.find('input[name="socialProvider[facebook][]"][value=' + page + ']').prop('checked', true);
              });
            }

          }

          if ($linkedIn.length) {
            $linkedInCheck.trigger('click');
          }

          if ($twitter.length) {
            $twitterCheck.trigger('click');
          }

        }

        var $fieldSocialNetworkWrapper = $('.field__social-network--wrapper', $modal);
        $fieldSocialNetworkWrapper.show().addClass('animated fadeIn');
      };

      return {
        getList: function () {
          _this.pageParams().setDefault();
          // Get all scheduled posts
          if (_this.getCampaignId()) {
            $.when(_this.getList()).done(function (response) {
              _this.pager().init(response);
            });
          }
        },

        init: function () {

          $(window).hashchange(function () {
            if (_this.getHash().indexOf('tab_') >= 0) {
              var dataStep = _this.getHash();

              switch (dataStep) {
                case 'tab_4' :
                  $('[data-campaign-name]').text($(':input[name=campaignName]').val());
                  _this.pageParams().setDefault();
                  // Get all scheduled posts
                  if (_this.getCampaignId()) {
                    $.when(_this.getList()).done(function (response) {
                      _this.pager().init(response);
                    });
                  }
                  break;
              }
            }
          });
          // Set Page Params to default or from storage
          _.isNull(_this.pageParams().get()) ? _this.pageParams().set(_this.getDefaultPageParams()) : null;

          // Set sorting on scheduled posts
          $('.scheduled_posts__list').mdcSort({
            'orderBy': _this.pageParams().get()['orderBy'],
            'orderByOrder': _this.pageParams().get()['orderByOrder'],
            callback: function (obj) {
              var pageParams = {orderBy: obj.orderBy, orderByOrder: obj.orderByOrder};
              _this.pageParams().set(pageParams);
              _this.getList();
            }
          });

          // Search box
          $(context + ' :input[name="q"]').val(_this.pageParams().get()['q']);

          $(document).off('change.socialNetwork__' + nameSpace).on('change.socialNetwork__' + nameSpace, context + ' :input[name="socialNetwork[]"]', function (e) {
            $('form[name="scheduled__list--search"]').submit();
          });

          $(document).off('change.status__' + nameSpace).on('change.status__' + nameSpace, context + ' :input[name="status"]', function (e) {
            $('form[name="scheduled__list--search"]').submit();
          });

          $(document).off('submit.' + nameSpace).on('submit.' + nameSpace, context + ' form[name="scheduled__list--search"]', function (e) {
            e.preventDefault();
            var $submitButton = $(this).find(':input[type=submit]');
            $submitButton.button('loading');
            var socialNetwork = _.map($(this).find(':input[name="socialNetwork[]"]:checked'), function (el) {
              return $(el).val()
            }).join(',');

            var pageParams = {
              q: $(this).find(':input[name="q"]').val(),
              socialNetwork: socialNetwork,
              status: $(this).find(':input[name="status"]').val(),
              date: $(this).find(':input[name="date"]').val(),
            };

            _this.pageParams().reset();
            _this.pageParams().set(pageParams);
            $.when(_this.getList()).done(function (response) {
              _this.pager().init(response);
              $submitButton.button('reset');
            });
          }).off('click.mass_actions__' + nameSpace).on('click.mass_actions__' + nameSpace, context + ' :input[name="mass_actions"]', function (e) {
            if ($(this).is(':checked')) {
              $(':input[name="ids[]"]').prop('checked', true);
            } else {
              $(':input[name="ids[]"]').prop('checked', false);
            }
          }).off('click.mass_actions__action' + nameSpace).on('click.mass_actions__action' + nameSpace, context + ' [data-action]', function (e) {
            var action = $(this).attr('data-action'),
              $button = $(this),
              $dataRow = $(this).closest('[data-row]'), message;

            switch (action) {
              case 'mass-delete':

                if ($(':input[name="ids[]"]:checked').length == 0) {
                  app.flashMessenger("error", "Please select a row first...");
                  return;
                }

                message = "Are you sure to delete selected posts?";

                $button.button('loading');
                alertify.confirm()
                  .set({
                    labels: {
                      ok: "Delete"
                    }
                  })
                  .set({reverseButtons: true, transition: 'zoom', 'modal': true})
                  .setHeader('Mass Action :: Delete')
                  .set('message', message)
                  .set('onok', function (e, value) {
                    e.cancel = true;
                    $('.ajs-button.ajs-ok').button('loading');
                    var massDelete = _this.scheduledPostsAction().mass().delete({keywords: value});
                    $.when(massDelete).done(function () {
                      alertify.confirm().close();
                      $('.ajs-button.ajs-ok').button('reset');
                      var data = _this.getList();
                      $.when(data).done(function (response) {
                        _this.pager().init(response);
                        $button.button('reset');
                      });

                    }).fail(function (response) {
                      $('.ajs-button.ajs-ok').button('reset');
                      $button.button('reset');
                    });
                  })
                  .set('oncancel', function (e) {
                    $button.button('reset');
                  })
                  .show();
                break;

            }
          })
          ;

          $('.btn-view-all-posts').off('click').on('click', function (e) {
            e.preventDefault();
            $(this).addClass('btn-primary').removeClass('btn-transparent');
            $('.desktop-calendar-picker .mask').show();
            $('.btn-view-by-date').removeClass('btn-primary').addClass('btn-transparent');
            var $form = $('form[name="scheduled__list--search"]');
            $(':input[name=date]', $form).val('');
            $form.submit();
          });

          $('.btn-view-by-date').off('click').on('click', function (e) {
            e.preventDefault();
            $(this).addClass('btn-primary').removeClass('btn-transparent');
            $('.desktop-calendar-picker .mask').hide();
            $('.btn-view-all-posts').removeClass('btn-primary').addClass('btn-transparent');
          });


          $('[data-filter-timepicker]').datetimepicker({
            inline: true,
            locale: 'en',
            keepOpen: true,
            ignoreReadonly: true,
            format: 'YYYY-MM-DD'
          }).on('dp.change', function (e) {
            if ($('.btn-view-by-date').hasClass('btn-primary')) {
              var $form = $('form[name="scheduled__list--search"]')
              $(':input[name=date]', $form).val(e.date.format('YYYY-MM-DD'));
              $form.submit();
            }
          });

          $dateTimePickerModal.datetimepicker({
            inline: true,
            locale: 'en',
            keepOpen: true,
            ignoreReadonly: true,
            sideBySide: true,
            minDate: moment(),
          }).on('dp.change', function (e) {
            var $dataModalCalendar = $('[data-modal-calendar]');
            $dataModalCalendar.find(':input[name="dateScheduled"]').val(moment(app.localToUtc(e.date)).unix()).removeAttr('disabled');
            $dataModalCalendar.find(':input[name="dataId"]').val($(e.target).closest('[data-row]').attr('data-row'));
          });

          $dateTimePickerModalReschedule.datetimepicker({
            inline: true,
            locale: 'en',
            keepOpen: true,
            ignoreReadonly: true,
            sideBySide: true,
            minDate: moment(),
          }).on('dp.change', function (e) {
            var $form = $('form[name="reschedule__form"]', $('[data-modal-reschedule-posts]'));
            $form.find(':input[name="dateScheduled"]').val(moment(app.localToUtc(e.date)).unix()).removeAttr('disabled');
          });

          $(document).off('click.datepicker__modal' + nameSpace).on('click.datepicker__modal' + nameSpace, context + ' .btn-calendar-modal', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var dataRow = $(this).closest('[data-row]');
            var $modal = $('[data-modal-calendar]');
            $modal.modal('show');

            var id = dataRow.attr('data-row'),
              scheduledDate = dataRow.find('[data-date]').attr('data-date');

            $modal.attr('data-row', id);
            $dateTimePickerModal.data('DateTimePicker').defaultDate(moment(scheduledDate));
          }).off('click.allreschedule__modal' + nameSpace).on('click.allreschedule__modal' + nameSpace, context + ' [data-action="mass-reschedule"]', function (e) {
            e.preventDefault();
            e.stopPropagation();

            if ($(':input[name="ids[]"]:checked').length == 0) {
              app.flashMessenger("error", "Please select a row first...");
              return;
            }

            var $modal = $('[data-modal-reschedule-posts]');
            $modal.find('.reschedule__post--step1').addClass('d-none');
            $modal.find('.reschedule__post--step2').removeClass('d-none');
            $modal.modal('show');

            var $fieldSocialNetworkWrapper = $('.field__social-network--wrapper', $modal);
            $fieldSocialNetworkWrapper.show().addClass('animated fadeIn');

            var $step2 = $modal.find('.reschedule__post--step2');
            $('[data-reschedule-step="prev"]', $step2).hide();

          }).off('click.reschedule__modal-with-date' + nameSpace).on('click.reschedule__modal-with-date' + nameSpace, context + ' [data-action="reschedule-modal-with-date"]', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var $button = $(this);
            var $modal = $('[data-modal-reschedule-posts]');
            var $step1 = $modal.find('.reschedule__post--step1');
            var $step2 = $modal.find('.reschedule__post--step2');
            var $dataRow = $(this).closest('[data-row]');
            $step1.removeClass('d-none');
            $step2.addClass('d-none');

            $button.closest('form').find('input[name="ids[]"]').prop('checked', false);
            $button.closest('.scheduled-post-row').find('input[name="ids[]"]').prop('checked', true);

            var id = $dataRow.attr('data-row'),
              scheduledDate = $dataRow.find('[data-date]').attr('data-date');

            $modal.attr('data-row', id);

            $modal.find('[data-reschedule-step]').off('click').on('click', function () {
              var $button = $(this);
              var action = $button.attr('data-reschedule-step');

              if (action == 'next') {
                $step1.addClass('d-none');
                $step2.removeClass('d-none');
                _this.handleSocialSelection($modal, $dataRow);
                $('[data-reschedule-step="prev"]', $step2).show();
              } else {
                $step2.addClass('d-none');
                $step1.removeClass('d-none');
              }

            });
            $modal.modal('show');


            var $form = $('form[name="reschedule__form"]', $modal);
            $form.find(':input[name="dateScheduled"]').val(moment(app.localToUtc(moment(scheduledDate))).unix()).removeAttr('disabled');
            $dateTimePickerModal.data('DateTimePicker').defaultDate(moment(scheduledDate));

          }).off('click.reschedule__modal' + nameSpace).on('click.reschedule__modal' + nameSpace, context + ' [data-action="reschedule-modal"]', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var $dataRow = $(this).closest('[data-row]');
            var $modal = $('[data-modal-reschedule-posts]');
            $modal.find('.reschedule__post--step1').addClass('d-none');
            $modal.find('.reschedule__post--step2').removeClass('d-none');
            $modal.modal('show');

            _this.handleSocialSelection($modal, $dataRow);

            $(this).closest('form').find('input[name="ids[]"]').prop('checked', false);
            $(this).closest('.scheduled-post-row').find('input[name="ids[]"]').prop('checked', true);

            var $step2 = $modal.find('.reschedule__post--step2');
            $('[data-reschedule-step="prev"]', $step2).hide();

          }).off('click.rescheduler__' + nameSpace).on('click.rescheduler__' + nameSpace, context + ' [data-rescheduler]', function (e) {
            var $form = $('form[name=reschedule__form]');
            e.preventDefault();
            $form.submit();
          }).off('click.editor__modal' + nameSpace).on('click.editor__modal' + nameSpace, '[data-modal-edit-post] [data-action-edit-post]', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var $postModal = $('[data-modal-edit-post]');
            var $modal = $('[ data-modal-editor]');
            $modal.modal('show');

            var id = $postModal.find('[data-id]').attr('data-id');
            var text = $postModal.find('.col__text').html();
            $('textarea[name=content]').val(text);
            $modal.find(':input[name=id]').val(id);
          });

          $(document).off('submit.rescheduler__' + nameSpace).on('submit.rescheduler__' + nameSpace, 'form[name=reschedule__form]', function (e) {
            e.preventDefault();
            var $submitButton = $(this).find(':input[type=submit]');
            $submitButton.button('loading');
            $.when(_this.scheduledPostsAction().mass().reschedule()).done(function () {
              $submitButton.button('reset');
              $.when(_this.getList()).done(function (response) {
                _this.pager().init(response);
              });
            }).fail(function () {
              $submitButton.button('reset');
            });
          });

          $(document).off('click.campaign__list--action').on('click.campaign_list-action', context + ' [data-action]', function (e) {
            e.preventDefault();
            var action = $(this).attr('data-action'),
              postId = $(this).attr('data-id'),
              $button = $(this),
              $dataRow = $(this).closest('[data-row]'),
              postText = $dataRow.find('.post__text [data-text]').html(),
              postImage = $dataRow.find('.post__image img').attr('data-url'),
              postDate = $dataRow.find('.col__date-scheduled').attr('data-date'),
              message = "<div class='post-delete-confirmation'>" +
                '<div class="post__text mb-2">' +
                $dataRow.find('.post__text').html() +
                '</div>' +
                '<div class="post__image m-progress">' +
                '<img src="/images/blank.gif" data-src="' + $dataRow.find('.post__image img').attr('data-url') + '" class="lazy img-fluid">' +
                '</div>' +
                '</div>';
            switch (action) {
              case 'edit-campaign-name' :
                $modal = $('[data-modal-campaign-name]');
                $modal.find(':input[name=editCampaignNameStep4]').val($(':input[name=campaignName]').val());
                $modal.modal('show');
                break;
              case 'mobile-calendar' :
                $('[data-modal-filter-calendar]').modal('show');
                break;
              case 'edit' :
                var postEditMenu = _.template(templates.postEditMenu);
                if (typeof $(this).attr('aria-describedby') == 'undefined') {
                  $(this).popover({
                    container: $(context),
                    'content': postEditMenu,
                    'placement': 'bottom',
                    'html': true,
                    'offset': "115, 0"
                  });
                  $(this).popover('show');
                }
                break;

              case 'view' :
                var $modal = $('[data-modal-edit-post]'),
                  $modalBody = $modal.find('.modal__post');
                $modalBody.html('');
                appCampaign.renderPostRow('facebookPost', {
                  'id': postId,
                  'username': '',
                  'dateScheduled': {'date': postDate},
                  'text': postText,
                  'image': postImage
                }, $modalBody);
                $modal.modal('show');
                app.lazyLoadImage($modal);
                break;
              case 'trash':
                $button.button('loading');
                var isReminder = $dataRow.hasClass('status-reminder');
                alertify.confirm()
                  .set({
                    labels: {
                      ok: "Delete"
                    }
                  })
                  .set({reverseButtons: true, transition: 'zoom', 'modal': true})
                  .setHeader('Confirm Post Delete')
                  .set('message', message)
                  .set('onok', function (e) {
                    e.cancel = true;
                    $('.ajs-button.ajs-ok').button('loading');
                    if (typeof postId != 'undefined' && postId != '') {
                      var deletePost = isReminder ? _this.scheduledPostsAction().deleteReminder(postId) : _this.scheduledPostsAction().delete(postId);
                      $.when(deletePost).done(function () {
                        alertify.confirm().close();
                        $('.ajs-button.ajs-ok').button('reset');
                        $.when(_this.getList()).done(function (response) {
                          _this.pager().init(response);
                          $button.button('reset');
                        });
                      }).fail(function () {
                        $button.button('reset');
                      });
                    } else {
                      alertify.confirm().close();
                      $('.ajs-button.ajs-ok').button('reset');
                      $.when(_this.getList()).done(function (response) {
                        _this.pager().init(response);
                        $button.button('reset');
                      });
                    }
                  })
                  .set('oncancel', function () {
                    $button.button('reset');
                  })
                  .show();
                app.lazyLoadImage($('.ajs-modal'));
                $('.ajs-header').addClass('alertify-scheduled-post-trash');
                $('.ajs-ok').addClass('alertify-scheduled-post-trash');
                break;
            }
          });

          $(document).off('click.save-campaign-name__' + nameSpace).on('click.save-campaign-name__' + nameSpace, '[data-action="save-campaign-name"]', function (e) {
            var $button = $(this);
            var $modal = $('[data-modal-campaign-name]');
            $button.button('loading');
            var campaignName = $modal.find(':input[name=editCampaignNameStep4]').val();
            $.when(_this.scheduledPostsAction().updateCampaign({
              'campaignName': campaignName
            })).done(function (response) {
              $(':input[name=campaignName]').val(campaignName);
              $('[data-campaign-name]').text(campaignName);
              $button.button('reset');
              $modal.modal('hide');
            });
          });

          // Posting Log click event
          $(document).off('click.post_log__modal' + nameSpace).on('click.post_log__modal' + nameSpace, context + ' [data-action="history-modal"]', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var dataId = $(this).data('id');
            var $modal = $('[data-modal-post-log]');
            var $body = $modal.find('.table__post-log-body');
            $body.html('');
            $modal.modal('show');

            $modal.find('[data-id]').text(dataId);
            $body.closest('table').addClass('loading-state');

            $.when(_this.scheduledPostsAction().history(dataId)).done(function (response) {
              _.each(response, function (row) {
                var postLog = _.template(app.templates["Post__campaign____row-post-log"]);
                var $postLog = $(
                  postLog(row)
                );
                $postLog.appendTo($body);
                $body.closest('table').removeClass('loading-state');
              });

            });

          });

          $('[data-modal-reschedule-posts]').on('hide.bs.modal', function (e) {
            var $form = $('form[name="reschedule__form"]', '[data-modal-reschedule-posts]');
            $form.find(':input[name="dateScheduled"]').attr('disabled', 'disabled').val('');
          });


          $('[data-modal-calendar]').on('hide.bs.modal', function (e) {
            var dataId = $(this).find(':input[name="dataId"]').val();
            var dateScheduled = $(this).find(':input[name="dateScheduled"]').val();
            if (_this.getHash() == 'tab_4') {
              if (typeof dataId != 'undefined' && dataId != '') {
                $.when(appCampaign.postActions().update(dataId, {'dateScheduled': dateScheduled})).done(function (response) {
                  $.when(_this.getList()).done(function (response) {
                    _this.pager().init(response);
                  });
                });
              }
            }

            if (_this.getHash() == 'tab_3') {
              if (typeof dataId != 'undefined' && dataId != '') {
                appCampaign.postActions().update(dataId, {'dateScheduled': dateScheduled});
              }

              var inputGroupField = $(e.target).closest('[data-input-group]').attr('data-input-group');
              var inputGroupForm = $(e.target).closest('[data-form]').attr('data-form');

              if (typeof inputGroupField != 'undefined' && inputGroupField != '') {
                $(':input[name="' + inputGroupField + '"]', $('form[name="' + inputGroupForm + '"]')).val(moment.unix(dateScheduled).format('YYYY-MM-DD HH:mm:ss')).attr('data-value', dateScheduled);
              }
            }

          });
        }
      };
    };
  });
})(PreBuilt);



